import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { CountryPipe } from "./address/country.pipe";
import { ProvincePipe } from "./address/province.pipe";
import { LocalDateTimeZonePipe } from "./date/local-date-time-zone.pipe";

@NgModule({
  imports: [CommonModule],
  exports: [
    CountryPipe,
    ProvincePipe,
    LocalDateTimeZonePipe
  ],
  declarations: [
    CountryPipe,
    ProvincePipe,
    LocalDateTimeZonePipe
  ],
  providers: [
  ]
})
export class PipeModule { }
